import serviceRequest from "utils/request";

const baseUrl = "/calculator";

export const calculateExpertPrice = (data) => {
	return serviceRequest({
		url: `${baseUrl}/calculate`,
		method: "post",
		data,
	});
};
